/** Reine Hilfsfunktionen für die Rechte-Matrix (Einstellungen -> Rechte). */

export interface MatrixZeile {
  schluessel: string;
  modul: string;
  aktion: string;
}

/** Alle Zellen der Matrix, modulweise sortiert (Modul x Aktion). */
export function matrixZeilen(module: string[], aktionen: string[]): MatrixZeile[] {
  const zeilen: MatrixZeile[] = [];
  for (const modul of module) {
    for (const aktion of aktionen) {
      zeilen.push({ schluessel: `${modul}.${aktion}`, modul, aktion });
    }
  }
  return zeilen;
}

/** Nur die Schlüssel, deren Wert in `neu` vom Wert in `alt` abweicht.
    Schlüssel, die in `neu` fehlen, werden ignoriert. */
export function diffMatrix(
  alt: Record<string, string>,
  neu: Record<string, string>,
): Record<string, string> {
  const diff: Record<string, string> = {};
  for (const schluessel of Object.keys(neu)) {
    if (alt[schluessel] !== neu[schluessel]) diff[schluessel] = neu[schluessel];
  }
  return diff;
}

export interface GruppierteSchluessel {
  /** Modulnamen (Präfix vor dem Punkt), Reihenfolge des ersten Auftretens */
  module: string[];
  /** Volle Schlüssel `faehigkeit.<name>` */
  faehigkeiten: string[];
  /** Volle Schlüssel `agent.<modul>` */
  agenten: string[];
}

/** Teilt Rechteschlüssel anhand des Präfixes in Module, Fähigkeiten und Agenten. */
export function gruppiereSchluessel(keys: string[]): GruppierteSchluessel {
  const module: string[] = [];
  const faehigkeiten: string[] = [];
  const agenten: string[] = [];
  for (const key of keys) {
    if (key.startsWith('faehigkeit.')) {
      faehigkeiten.push(key);
    } else if (key.startsWith('agent.')) {
      agenten.push(key);
    } else {
      const modul = key.split('.')[0];
      if (!module.includes(modul)) module.push(modul);
    }
  }
  return { module, faehigkeiten, agenten };
}

/** Ende des gewählten Tages als ISO-Zeitstempel (`YYYY-MM-DDT23:59:59`), damit eine
    Zuweisung "gültig bis 05.10." den ganzen 5. Oktober gilt. Leere Eingabe -> undefined. */
export function gueltigBisIso(datum: string): string | undefined {
  const d = datum.trim();
  return d ? `${d}T23:59:59` : undefined;
}
